/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AppSessionRequiredRouteImport } from './routes/app-session-required'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardRouteImport } from './routes/onboard'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AuthedCalendarRouteImport } from './routes/_authed.calendar'
import { Route as AuthedCustomersRouteImport } from './routes/_authed.customers'
import { Route as AuthedDashboardRouteImport } from './routes/_authed.dashboard'
import { Route as AuthedGroupsRouteImport } from './routes/_authed.groups'
import { Route as AuthedPaymentsRouteImport } from './routes/_authed.payments'
import { Route as AuthedReportsRouteImport } from './routes/_authed.reports'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedShippingRouteImport } from './routes/_authed.shipping'
import { Route as AuthedDetailGroupIdRouteImport } from './routes/_authed.detail-group.$id'
import { Route as AuthedOrderManagementIndexRouteImport } from './routes/_authed.order-management.index'
import { Route as AuthedOrderManagementNewRouteImport } from './routes/_authed.order-management.new'
import { Route as AuthedSettingsIndexRouteImport } from './routes/_authed.settings.index'
import { Route as AuthedSettingsJastipFeeRouteImport } from './routes/_authed.settings.jastip-fee'
import { Route as AuthedSettingsStoreRouteImport } from './routes/_authed.settings.store'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSessionRequiredRoute = AppSessionRequiredRouteImport.update({
  id: '/app-session-required',
  path: '/app-session-required',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardRoute = OnboardRouteImport.update({
  id: '/onboard',
  path: '/onboard',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedCalendarRoute = AuthedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCustomersRoute = AuthedCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGroupsRoute = AuthedGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentsRoute = AuthedPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedShippingRoute = AuthedShippingRouteImport.update({
  id: '/shipping',
  path: '/shipping',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDetailGroupIdRoute = AuthedDetailGroupIdRouteImport.update({
  id: '/detail-group/$id',
  path: '/detail-group/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrderManagementIndexRoute =
  AuthedOrderManagementIndexRouteImport.update({
    id: '/order-management/',
    path: '/order-management/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedOrderManagementNewRoute =
  AuthedOrderManagementNewRouteImport.update({
    id: '/order-management/new',
    path: '/order-management/new',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSettingsIndexRoute = AuthedSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsJastipFeeRoute = AuthedSettingsJastipFeeRouteImport.update({
  id: '/jastip-fee',
  path: '/jastip-fee',
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsStoreRoute = AuthedSettingsStoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => AuthedSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app-session-required': typeof AppSessionRequiredRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboard': typeof OnboardRoute
  '/register': typeof RegisterRoute
  '/calendar': typeof AuthedCalendarRoute
  '/customers': typeof AuthedCustomersRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/groups': typeof AuthedGroupsRoute
  '/payments': typeof AuthedPaymentsRoute
  '/reports': typeof AuthedReportsRoute
  '/settings': typeof AuthedSettingsRouteWithChildren
  '/shipping': typeof AuthedShippingRoute
  '/detail-group/$id': typeof AuthedDetailGroupIdRoute
  '/order-management/new': typeof AuthedOrderManagementNewRoute
  '/settings/jastip-fee': typeof AuthedSettingsJastipFeeRoute
  '/settings/store': typeof AuthedSettingsStoreRoute
  '/order-management/': typeof AuthedOrderManagementIndexRoute
  '/settings/': typeof AuthedSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app-session-required': typeof AppSessionRequiredRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboard': typeof OnboardRoute
  '/register': typeof RegisterRoute
  '/calendar': typeof AuthedCalendarRoute
  '/customers': typeof AuthedCustomersRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/groups': typeof AuthedGroupsRoute
  '/payments': typeof AuthedPaymentsRoute
  '/reports': typeof AuthedReportsRoute
  '/shipping': typeof AuthedShippingRoute
  '/detail-group/$id': typeof AuthedDetailGroupIdRoute
  '/order-management/new': typeof AuthedOrderManagementNewRoute
  '/settings/jastip-fee': typeof AuthedSettingsJastipFeeRoute
  '/settings/store': typeof AuthedSettingsStoreRoute
  '/order-management': typeof AuthedOrderManagementIndexRoute
  '/settings': typeof AuthedSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/app-session-required': typeof AppSessionRequiredRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboard': typeof OnboardRoute
  '/register': typeof RegisterRoute
  '/_authed/calendar': typeof AuthedCalendarRoute
  '/_authed/customers': typeof AuthedCustomersRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/groups': typeof AuthedGroupsRoute
  '/_authed/payments': typeof AuthedPaymentsRoute
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/settings': typeof AuthedSettingsRouteWithChildren
  '/_authed/shipping': typeof AuthedShippingRoute
  '/_authed/detail-group/$id': typeof AuthedDetailGroupIdRoute
  '/_authed/order-management/new': typeof AuthedOrderManagementNewRoute
  '/_authed/settings/jastip-fee': typeof AuthedSettingsJastipFeeRoute
  '/_authed/settings/store': typeof AuthedSettingsStoreRoute
  '/_authed/order-management/': typeof AuthedOrderManagementIndexRoute
  '/_authed/settings/': typeof AuthedSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app-session-required'
    | '/forgot-password'
    | '/login'
    | '/onboard'
    | '/register'
    | '/calendar'
    | '/customers'
    | '/dashboard'
    | '/groups'
    | '/payments'
    | '/reports'
    | '/settings'
    | '/shipping'
    | '/detail-group/$id'
    | '/order-management/new'
    | '/settings/jastip-fee'
    | '/settings/store'
    | '/order-management/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app-session-required'
    | '/forgot-password'
    | '/login'
    | '/onboard'
    | '/register'
    | '/calendar'
    | '/customers'
    | '/dashboard'
    | '/groups'
    | '/payments'
    | '/reports'
    | '/shipping'
    | '/detail-group/$id'
    | '/order-management/new'
    | '/settings/jastip-fee'
    | '/settings/store'
    | '/order-management'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/app-session-required'
    | '/forgot-password'
    | '/login'
    | '/onboard'
    | '/register'
    | '/_authed/calendar'
    | '/_authed/customers'
    | '/_authed/dashboard'
    | '/_authed/groups'
    | '/_authed/payments'
    | '/_authed/reports'
    | '/_authed/settings'
    | '/_authed/shipping'
    | '/_authed/detail-group/$id'
    | '/_authed/order-management/new'
    | '/_authed/settings/jastip-fee'
    | '/_authed/settings/store'
    | '/_authed/order-management/'
    | '/_authed/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  AppSessionRequiredRoute: typeof AppSessionRequiredRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardRoute: typeof OnboardRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-session-required': {
      id: '/app-session-required'
      path: '/app-session-required'
      fullPath: '/app-session-required'
      preLoaderRoute: typeof AppSessionRequiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboard': {
      id: '/onboard'
      path: '/onboard'
      fullPath: '/onboard'
      preLoaderRoute: typeof OnboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/calendar': {
      id: '/_authed/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthedCalendarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers': {
      id: '/_authed/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthedCustomersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/groups': {
      id: '/_authed/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AuthedGroupsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payments': {
      id: '/_authed/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthedPaymentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/shipping': {
      id: '/_authed/shipping'
      path: '/shipping'
      fullPath: '/shipping'
      preLoaderRoute: typeof AuthedShippingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/detail-group/$id': {
      id: '/_authed/detail-group/$id'
      path: '/detail-group/$id'
      fullPath: '/detail-group/$id'
      preLoaderRoute: typeof AuthedDetailGroupIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/order-management/': {
      id: '/_authed/order-management/'
      path: '/order-management'
      fullPath: '/order-management/'
      preLoaderRoute: typeof AuthedOrderManagementIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/order-management/new': {
      id: '/_authed/order-management/new'
      path: '/order-management/new'
      fullPath: '/order-management/new'
      preLoaderRoute: typeof AuthedOrderManagementNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/': {
      id: '/_authed/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthedSettingsIndexRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/settings/jastip-fee': {
      id: '/_authed/settings/jastip-fee'
      path: '/jastip-fee'
      fullPath: '/settings/jastip-fee'
      preLoaderRoute: typeof AuthedSettingsJastipFeeRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    '/_authed/settings/store': {
      id: '/_authed/settings/store'
      path: '/store'
      fullPath: '/settings/store'
      preLoaderRoute: typeof AuthedSettingsStoreRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
  }
}

interface AuthedSettingsRouteChildren {
  AuthedSettingsJastipFeeRoute: typeof AuthedSettingsJastipFeeRoute
  AuthedSettingsStoreRoute: typeof AuthedSettingsStoreRoute
  AuthedSettingsIndexRoute: typeof AuthedSettingsIndexRoute
}

const AuthedSettingsRouteChildren: AuthedSettingsRouteChildren = {
  AuthedSettingsJastipFeeRoute: AuthedSettingsJastipFeeRoute,
  AuthedSettingsStoreRoute: AuthedSettingsStoreRoute,
  AuthedSettingsIndexRoute: AuthedSettingsIndexRoute,
}

const AuthedSettingsRouteWithChildren = AuthedSettingsRoute._addFileChildren(
  AuthedSettingsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedCalendarRoute: typeof AuthedCalendarRoute
  AuthedCustomersRoute: typeof AuthedCustomersRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedGroupsRoute: typeof AuthedGroupsRoute
  AuthedPaymentsRoute: typeof AuthedPaymentsRoute
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedSettingsRoute: typeof AuthedSettingsRouteWithChildren
  AuthedShippingRoute: typeof AuthedShippingRoute
  AuthedDetailGroupIdRoute: typeof AuthedDetailGroupIdRoute
  AuthedOrderManagementNewRoute: typeof AuthedOrderManagementNewRoute
  AuthedOrderManagementIndexRoute: typeof AuthedOrderManagementIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedCalendarRoute: AuthedCalendarRoute,
  AuthedCustomersRoute: AuthedCustomersRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedGroupsRoute: AuthedGroupsRoute,
  AuthedPaymentsRoute: AuthedPaymentsRoute,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedSettingsRoute: AuthedSettingsRouteWithChildren,
  AuthedShippingRoute: AuthedShippingRoute,
  AuthedDetailGroupIdRoute: AuthedDetailGroupIdRoute,
  AuthedOrderManagementNewRoute: AuthedOrderManagementNewRoute,
  AuthedOrderManagementIndexRoute: AuthedOrderManagementIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  AppSessionRequiredRoute: AppSessionRequiredRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardRoute: OnboardRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
